import dayjs from "dayjs";

// example: 2025-10-25 => 10th Sep
// 需要用dayjs返回 这个格式 10th Sep
const getOrdinalSuffix = (day: number) => {
  if (day >= 11 && day <= 13) return "th";

  // 1 --> 1st, 2 --> 2nd, 3 --> 3rd, 21 --> 21st, 22 --> 22nd, 23 --> 23rd, 31 --> 31st
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatDateToEnglish = (date: string) => {
  const d = dayjs(`${date} 00:00:00`);
  const day = d.date();
  const suffix = getOrdinalSuffix(day);

  return `${day}${suffix} ${d.format("MMM")}`;
};

/**
 * 将日期格式化为 DD/MM 格式
 * @param date 日期字符串，格式如 "2025-01-01"
 * @returns 格式化后的日期字符串，如 "01/01"
 * @example
 * formatDate("2025-04-12") // "12/04"
 */
export const formatDate = (date: string): string => {
  const d = dayjs(date);
  return d.format("DD/MM");
};
